import { type IPublicClientApplication } from '@azure/msal-browser';

import { loginRequest } from './utils';

export type GetIdTokenFn = (options?: { forceRefresh?: boolean }) => Promise<string>;

export function createGetIdTokenFunction(msalInstance: IPublicClientApplication): GetIdTokenFn {
  return async function (options?: { forceRefresh?: boolean }): Promise<string> {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      throw new Error('No active account found. Please log in first.');
    }

    try {
      return (
        await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account,
          forceRefresh: options?.forceRefresh ?? false,
        })
      ).idToken;
    } catch (error) {
      console.error('AuthError: ', error);
      await msalInstance.loginRedirect(loginRequest);
      return (
        await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account,
        })
      ).idToken;
    }
  };
}
